import { render, staticRenderFns } from "./paymentService.vue?vue&type=template&id=e532bae2"
import script from "./paymentService.vue?vue&type=script&lang=js"
export * from "./paymentService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports